/* pdpx landing PDP. Each part initialises per section root and again after theme-editor edits (shopify:section:load).
   Buy box config = the JSON the buy-box section prints (prices in cents, from the product's variants unless overridden). */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var TRACK = (function () { /* ad + ClickMagick params ride along to checkout as order attributes */
    var k = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'cmc_vid', 'cmc_adid', 'gc_id', 'g_special_campaign', 'h_ad_id'], q = new URLSearchParams(location.search), t = {};
    try { t = JSON.parse(sessionStorage.getItem('rv_track') || '{}'); } catch (e) {}
    k.forEach(function (n) { var v = q.get(n); if (v && v.indexOf('[') !== 0) t[n] = v.slice(0, 250); });
    try { sessionStorage.setItem('rv_track', JSON.stringify(t)); } catch (e) {}
    return t;
  })();

  function initBuy(root) {
    var cfgEl = $('[data-pdpx-buy]', root); if (!cfgEl || cfgEl.dataset.ready) return; cfgEl.dataset.ready = 1;
    var C = {}; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var keys = Object.keys(C.min || {}).filter(function (k) { return C.unit && C.unit[k] > 0; }).sort(function (a, b) { return C.min[a] - C.min[b]; });
    if (!keys.length) return;                                   /* no usable tier: leave the server-rendered text alone */
    var fmt; try { fmt = new Intl.NumberFormat(C.locale || 'en', { style: 'currency', currency: C.currency || 'USD' }); } catch (e) { fmt = null; }
    var money = function (c) { var n = c / 100; return fmt ? fmt.format(n) : n.toFixed(2); };
    var first = keys[0], top = keys[keys.length - 1], SINGLE = C.compare_unit > 0 ? C.compare_unit : C.unit[first], MAX = C.max || 10, qty = C.min[first] || 1;
    /* Tiers that share a minimum are a choice (e.g. colour), not a quantity break: remember which one was picked. */
    var onEl = $('.tier.on', root), pick = onEl ? onEl.getAttribute('data-tier') : first;
    if (!(pick in C.min)) pick = first;
    var sameMin = function (k) { return C.min[k] === C.min[pick]; };
    var isChoice = keys.filter(sameMin).length > 1;
    var label = {}; keys.forEach(function (k) { var e = $('.tier[data-tier="' + k + '"] [data-name]', root); label[k] = e ? e.textContent.trim() : ''; });
    var tierOf = function (n) { var t = first; keys.forEach(function (k) { if (n >= C.min[k] && (!sameMin(k) || k === pick)) t = k; }); return t; };
    var topName = isChoice ? null : $('.tier[data-tier="' + top + '"] [data-name]', root), topLabel = topName ? topName.textContent : '';
    var sticky = $('[data-sticky]', document.body), toast = $('[data-toast]', root.parentNode || document) || $('[data-toast]');
    var cartUrl = function () {
      if (!C.checkout) return null;
      var FS_MAP = {
        'cosari-swift-v7': 'https://getcosari.com/checkout-swift-v7',
        'cosari-handy-h5': 'https://getcosari.com/checkout-handy-h5',
        'cosari-clearair-300': 'https://getcosari.com/checkout-clearair-300',
        'cosari-vista-d4': 'https://getcosari.com/checkout-vista-d4',
        'cosari-edge-r3': 'https://getcosari.com/checkout-edge-r3',
        'cosari-pulse-s1': 'https://getcosari.com/checkout-pulse-s1',
        'cosari-crispa-8': 'https://getcosari.com/checkout-crispa-8',
        'cosari-window-pro': 'https://getcosari.com/checkout-window-pro'
      };
      var pgSlug = (location.pathname.split('/pages/')[1] || '').split('/')[0].split('?')[0];
      if (FS_MAP[pgSlug]) {
        var fsu = new URLSearchParams(); fsu.set('ks_qty', String(qty || 1));
        if (isChoice && label[tierOf(qty)]) fsu.set('ks_var', label[tierOf(qty)]);
        Object.keys(TRACK).forEach(function (n) { fsu.set(n, TRACK[n]); });
        if (window.clickmagick_cmc && window.clickmagick_cmc.vid) fsu.set('cmc_vid', window.clickmagick_cmc.vid);
        return FS_MAP[pgSlug] + '?' + fsu.toString();
      }
      var v = (C.variants || {})[tierOf(qty)]; if (!v) return null;
      var u = new URLSearchParams(), cm = window.clickmagick_cmc;
      if (C.landing) u.set('attributes[ad_landing_page]', C.landing);
      Object.keys(TRACK).forEach(function (n) { u.set('attributes[ad_' + n + ']', TRACK[n]); });
      if (cm && cm.vid) u.set('attributes[ad_cm_visitor]', cm.vid);
      return (C.cart || '/cart') + '/' + v + ':' + qty + '?' + u.toString();
    };
    var render = function () {
      var t = tierOf(qty), total = C.unit[t] * qty, was = SINGLE * qty, save = was - total;
      var q = $('[data-qty]', root); if (q) q.textContent = qty;
      var tt = $('[data-total]', root); if (tt) tt.textContent = money(total);
      var w = $('[data-was]', root), s = $('[data-save]', root);
      if (w && s) { w.hidden = s.hidden = save <= 0; if (save > 0) { w.textContent = money(was); s.textContent = (C.save_prefix || '') + money(save); } }
      var sp = $('[data-s-price]'); if (sp) sp.textContent = money(total) + (qty > 1 ? ' · ' + qty + ' ' + C.plural : '');
      if (topName) topName.textContent = qty > C.min[top] ? qty + ' ' + C.plural : topLabel;
      $$('.tier', root).forEach(function (el) { var on = el.getAttribute('data-tier') === t; el.classList.toggle('on', on); var i = $('input', el); if (i) i.checked = on; });
      var mi = $('.step [data-step="-1"]', root), pl = $('.step [data-step="1"]', root);
      if (mi) mi.disabled = qty <= (C.min[first] || 1); if (pl) pl.disabled = qty >= MAX;
    };
    $$('.tier input', root).forEach(function (i) { i.addEventListener('change', function () { var tr = i.closest('.tier'); if (tr && tr.getAttribute('data-tier') in C.min) pick = tr.getAttribute('data-tier'); qty = isChoice ? qty : (+i.value || 1); render(); }); });
    $$('.step button', root).forEach(function (b) { b.addEventListener('click', function () { qty = Math.min(MAX, Math.max(C.min[first] || 1, qty + +b.getAttribute('data-step'))); render(); }); });
    var buy = function (e) {
      e.preventDefault(); var u = cartUrl();
      if (!u) { if (toast) { toast.textContent = C.toast || ''; toast.hidden = !C.toast; setTimeout(function () { toast.hidden = true; }, 2500); } return; }
      location.href = u;
    };
    $$('[data-buy]', root).concat($$('[data-buy2]')).forEach(function (a) { if (!a.dataset.bound) { a.dataset.bound = 1; a.addEventListener('click', buy); } });
    var main = $('[data-main]', root);
    $$('.thumbs button', root).forEach(function (b) {
      b.addEventListener('click', function () { if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-src'); } $$('.thumbs button', root).forEach(function (x) { x.classList.toggle('on', x === b); }); });
    });
    var atc = $('[data-buy]', root);
    if (sticky && atc && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (x) { sticky.classList.toggle('show', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(atc);
    render();
  }

  function initReviews(root) {
    var g = $('.dr-grid', root), m = $('.dr-moreb', root); if (!g || g.dataset.ready) return; g.dataset.ready = 1;
    if (m) { if (!$('.dr-c.more', g)) m.hidden = true; m.addEventListener('click', function () { g.classList.add('open'); m.hidden = true; }); }
    var chips = $$('.dr-chips button', root), firstChip = chips[0];
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-f');
        chips.forEach(function (x) { x.classList.toggle('on', x === b); });
        if (b !== firstChip) { g.classList.add('open'); if (m) m.hidden = true; }
        $$('.dr-c', g).forEach(function (c) { c.style.display = (b === firstChip || (c.getAttribute('data-t') || '').split(' ').indexOf(f) > -1) ? '' : 'none'; });
      });
    });
    var sb = $('[data-sort="helpful"]', root);
    if (sb) sb.addEventListener('click', function () {
      var cards = $$('.dr-c', g).sort(function (a, b) { return (+b.dataset.helpful || 0) - (+a.dataset.helpful || 0); });
      cards.forEach(function (c) { g.appendChild(c); }); g.classList.add('open'); if (m) m.hidden = true; sb.classList.add('on');
    });
  }

  function initCountdown(root) {
    $$('[data-end]', root).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = 1;
      var raw = el.getAttribute('data-end'), out = $('[data-cd]', el), end;
      if (raw === 'midnight') { var m = new Date(); m.setHours(24, 0, 0, 0); end = +m; } else end = +raw * 1000;
      var tick = function () {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (!s) { el.hidden = true; return; }
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mn = Math.floor(s % 3600 / 60), sc = s % 60, p = function (n) { return (n < 10 ? '0' : '') + n; };
        out.textContent = (d ? d + 'd ' : '') + p(h) + ':' + p(mn) + ':' + p(sc); setTimeout(tick, 1000);
      };
      tick();
    });
  }

  function init(root) { initBuy(root); initReviews(root); initCountdown(root); }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
/* theme editor: selecting a hidden review / closed FAQ shows it */
(function () {
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target, g = el.closest && el.closest('.dr-grid');
    if (g) { g.classList.add('open'); var m = g.parentNode.querySelector('.dr-moreb'); if (m) m.hidden = true; Array.prototype.forEach.call(g.querySelectorAll('.dr-c'), function (c) { c.style.display = ''; }); }
    var d = el.tagName === 'DETAILS' ? el : el.closest && el.closest('details'); if (d) { d.open = true; d.dataset.pdpxOpened = 1; }
    if (el.scrollIntoView) el.scrollIntoView({ block: 'center' });
  });
  document.addEventListener('shopify:block:deselect', function (e) { var d = e.target.closest && e.target.closest('details[data-pdpx-opened]'); if (d) { d.open = false; delete d.dataset.pdpxOpened; } });
})();
